import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/cssxp-client-utils';
import {
  FetchCloudSiteProductAppAndSubscriptionsForOrganizationQuery,
  FetchCloudSiteProductAppAndSubscriptionsForOrganizationQueryVariables,
  FilterOption,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchCloudSiteProductAppAndSubscriptionsForOrganization } from '../queries/fetch-cloud-site-products';

const buildSearchFilters = (searchInput: string | undefined) => {
  if (!searchInput) {
    return [];
  }
  searchInput = searchInput.trim();

  return [{ productNameText: searchInput }, { entitlementNumber: searchInput }];
};

export const isEmpty = (productsAppsAndSubscriptions: any, groupedProductDataError: any) => {
  if (groupedProductDataError || !productsAppsAndSubscriptions) {
    return true;
  }

  const { jira = {}, confluence = {}, statuspage = {}, other = {} } = productsAppsAndSubscriptions as Record<
    string,
    any
  >;

  const totalJiraProducts = jira.products?.length || 0;
  const totalConfluenceProducts = confluence.products?.length || 0;
  const totalStatuspageProducts = statuspage.products?.length || 0;
  const totalOtherProducts = other.products?.length || 0;

  const totalProducts = totalJiraProducts + totalConfluenceProducts + totalStatuspageProducts + totalOtherProducts;

  return totalProducts === 0;
};

const useFetchCloudSiteGroupedProducts = (filterOptions?: FilterOption[]) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);

  const getCloudsiteGroupedProducts = async (node: any, txaId: string, searchedInput: string | undefined) => {
    const queryVarsForGroupedProductAndApps = {
      parentSen: node.parentEntitlementId || '',
      cloudSiteId: node.cloudSiteId,
      organizationId: '',
      transactionAccountId: txaId,
      filterOptions: filterOptions || [
        {
          key: 'or',
          value: JSON.stringify(buildSearchFilters(searchedInput)),
        },
        {
          key: 'or',
          value: JSON.stringify([{ transactionAccountId: txaId }]),
        },
      ],
    };
    const {
      error: groupedProductDataError,
      loading: groupedProductDataLoading,
      data: groupedProductData,
    } = await ansClient.query<
      FetchCloudSiteProductAppAndSubscriptionsForOrganizationQuery,
      FetchCloudSiteProductAppAndSubscriptionsForOrganizationQueryVariables
    >({
      query: fetchCloudSiteProductAppAndSubscriptionsForOrganization,
      variables: queryVarsForGroupedProductAndApps,
    });

    return { groupedProductDataError, groupedProductDataLoading, groupedProductData };
  };

  return { getCloudsiteGroupedProducts };
};

export default useFetchCloudSiteGroupedProducts;
